import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../../../../store/store';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import QuestionnaireResultsButton from './QuestionnaireResultsButton';

loadDOMComponent({
	selector: 'react-questionnaire-results-button',
	callback: ({ container, context, props }: any) => {
		const patientId = container.getAttribute('patientId');
		const questionnaireCode = container.getAttribute('questionnaireCode');
		const questionnaireName = container.getAttribute('questionnaireName');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<QuestionnaireResultsButton
							patientId={patientId}
							questionnaireCode={questionnaireCode}
							questionnaireName={questionnaireName}
						/>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
